export default __webpack_public_path__ + "static/media/area-18.e4f6cf8d.jpg";